import { render, staticRenderFns } from "./DialogProductTour.vue?vue&type=template&id=bb77afd8&scoped=true"
import script from "./DialogProductTour.vue?vue&type=script&lang=js"
export * from "./DialogProductTour.vue?vue&type=script&lang=js"
import style0 from "./DialogProductTour.vue?vue&type=style&index=0&id=bb77afd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb77afd8",
  null
  
)

export default component.exports